const locale = {
	PERSOMAT: "Persomat",
	OVERVIEW: "Übersicht",
	WELCOMEBACK: "Willkommen zurück",
};

export default locale;
